module.exports = __webpack_public_path__ + "img/archived.ceb22b54.svg";